import { useCallback, useState } from "react";
import { ORDER, SORTING } from "./constants";

export interface LeadTableSortingAction {
  type?: string;
}

export interface LeadTableSortingHook {
  sorting: string;
  order: string;
  onAction: (action?: LeadTableSortingAction) => void;
}

export default function useLeadTableSorting(): LeadTableSortingHook {
  const [sorting, setSorting] = useState(SORTING.UPDATED_AT);
  const [order, setOrder] = useState(ORDER.NORMAL);

  const onAction = useCallback(
    (action: LeadTableSortingAction = {}) => {
      const { type } = action;

      if (type === "id-alphabetical") {
        if (sorting !== SORTING.ID) {
          setSorting(SORTING.ID);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      setSorting(SORTING.UPDATED_AT);
      setOrder(ORDER.NORMAL);
    },
    [order, sorting]
  );

  return {
    sorting,
    order,
    onAction,
  };
}
